import React from "react";

const RepCount = ({ repCount }) => {
  return (
    <span className="z-index-1 color-red-2 stopwatch-text">
      <span className="w-70-percent text-align-center">
        <strong className="white-space-pre">COUNT: </strong>
      </span>
      <span className="w-30-percent text-align-center">
        <strong>{repCount}</strong>
      </span>
    </span>
  );
};

export default RepCount;
